<div class="row">
    <div class="col-md-4" *ngFor="let m of menuItems" style="margin-top:20px;">
        <div class="card" (click)="menuClick (m)">
            <div class="card-body" style="cursor: pointer;">
                <h3 style="font-size: 17px;">&nbsp; {{m.name}}</h3>
            </div>
        </div>
    </div>
</div>